<template>
  <section class="cargo-capacity">
    <dl class="loads">
      <div class="load">
        <dt>Вес, кг</dt>
        <dd>
          <VehicleLoadBar layout="fill" :load="cargoWeightGross" :capacity="vehicle?.maxWeight ?? null"/>
        </dd>
      </div>

      <div class="load">
        <dt>Места</dt>
        <dd>
          <VehicleLoadBar layout="fill" :load="cargoUnitsCount" :capacity="vehicle?.cargoPlacesCount ?? null"/>
        </dd>
      </div>

      <div class="load">
        <dt>Объём, м³</dt>
        <dd>
          <VehicleLoadBar layout="fill" :load="cargoVolume" :capacity="vehicle?.maxVolume ?? null"/>
        </dd>
      </div>
    </dl>

    <p v-if="vehicle !== null" class="vehicle">{{ vehicle.nameFull }}</p>
  </section>
</template>

<style lang="scss" src="./CargoCapacity.scss"/>

<script lang="ts">

import VehicleLoadBar from '@/domains/TransportOrders/components/VehicleLoadBar/VehicleLoadBar.vue';
import type Vehicle from '@/domains/Vehicles/Vehicle';
import type Weight from '@/core/types/Weight';
import type Volume from '@/core/types/Volume';
import type Qty from '@/core/types/Qty';

/**
 * CargoCapacity — загрузка транспорта ЗТК: вес, места, объём.
 *
 * Над барами — описание транспорта (тип, температура, лимиты).
 * Транспорт не выбран — описания нет, бары показывают погруженное, справа «--».
 *
 * @example
 * <CargoCapacity
 *   :vehicle="transportOrder.vehicle"
 *   :cargo-weight-gross="transportOrder.cargoWeightGross"
 *   :cargo-units-count="transportOrder.cargoUnitsCount"
 *   :cargo-volume="transportOrder.cargoVolume"
 * />
 */
export default defineComponent({
  name: 'CargoCapacity',

  components: { VehicleLoadBar },

  props: {
    /** Транспорт; null — не выбран */
    vehicle: {
      type:    Object as PropType<Vehicle | null>,
      default: null,
    },

    cargoWeightGross: {
      type:    Object as PropType<Weight | null>,
      default: null,
    },

    /** Паллетоместа */
    cargoUnitsCount: {
      type:    Object as PropType<Qty | null>,
      default: null,
    },

    cargoVolume: {
      type:    Object as PropType<Volume | null>,
      default: null,
    },
  },
});
</script>